import { render, staticRenderFns } from "./CallsGiftsReportProject.vue?vue&type=template&id=02a3cbd0&scoped=true"
import script from "./CallsGiftsReportProject.vue?vue&type=script&lang=js"
export * from "./CallsGiftsReportProject.vue?vue&type=script&lang=js"
import style0 from "./CallsGiftsReportProject.vue?vue&type=style&index=0&id=02a3cbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a3cbd0",
  null
  
)

export default component.exports